import VatiaCheckoutSizes from "./VatiaCheckoutSizes";
import {motion} from "framer-motion";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import StripeCreditCardForm from "./StripeCreditCardForm";
import {Card} from "@mui/material";
import {Col, Row} from "reactstrap";
import React from "react";
import {getBackendUrl} from "./vatia-functions";
import {FormattedMessage, useIntl} from "react-intl";

export default function VatiaCheckoutStep3(props)
{
    const intl = useIntl()

    const date = new Date();
    let month = date.getMonth() < 11 ? date.getMonth()+1 : 0;
    let year = date.getMonth() < 11 ? date.getFullYear() : date.getFullYear()+1;

    const formatter = new Intl.NumberFormat('de-CH', {
        style: 'currency',
        currency: 'CHF',

        // These options are needed to round to whole numbers if that's what you want.
        //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
        //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
    });

    let changeElement = <span style={{fontSize:10, color:"#8a8989", textDecoration:"none"}}>
                                <FormattedMessage id={ 'abo.new.step3.change' } defaultMessage={ 'ändern'} />
                            </span>

    return (<motion.div
        className="box"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
    >
        <Row style={{textAlign: "left", maxWidth:570, marginLeft:"auto", marginRight:props.width>props.breakpoint ? 80 : 10,
            paddingLeft:0, paddingRight:0}}>
            <h4 style={{marginTop:20}}>
                <FormattedMessage id={ 'abo.new.navigation.step4.summary' } defaultMessage={ 'Zusammenfassung'} />
            </h4>
            <Card variant="outlined"
                  sx={{
                      padding:2,
                      paddingTop:4,
                      maxWidth: 570,
                      marginTop:0,
                      width: "100%",
                      // minHeight: 300,
                      // display: "inline-block",
                      marginRight: 1,
                      cursor: "pointer",
                      textAlign: "left"
                      // fontWeight: 600,
                      // borderColor: index == props.selectedTimeframe ? "green" : props.cards[index]
                  }}
                // onClick={() => props.handleTimeframeUpdate(index, range.title, range.price)}
                // onMouseEnter={(event) => {var cards = this.state.cards; cards[index] = 'black'; this.setState({cards:cards })}}
                // onMouseLeave={(event) => {var cards = this.state.cards; cards[index] = 'grey'; this.setState({cards:cards })}}
            >
                <Row style={{fontSize:14}}>
                    <Col xl={4} lg={4} md={4} sm={4} xs={12}>
                        <strong>
                            <FormattedMessage id={ 'abo.new.navigation.step1.size' } defaultMessage={ 'Grösse'} />
                        </strong><br/>
                        <FormattedMessage id={ 'abo.new.summary.top.title' } defaultMessage={ 'Dr. Brauwolf Abo'} /><br/>
                        {props.planTitle}<br/>
                         <a style={{textDecoration:"none"}} onClick={props.handleStep(0)}>
                             {changeElement}
                         </a><br/>
                        <br/><br/>
                    </Col>
                    <Col xl={4} lg={4} md={4} sm={4} xs={12}>
                        <strong>
                            <FormattedMessage id={ 'abo.new.navigation.step2.timeframe' } defaultMessage={ 'Laufzeit'} />
                        </strong><br/>
                        {props.timeframeTitle}{props.timeframeMonths == 1 ? <><span> <FormattedMessage id={ 'abo.new.step3.cancellable' } defaultMessage={ 'kündbar'} /></span></> : <><br/><span> Einmalige Zahlung</span></>}<br/>
                        CHF {props.priceAmount}.-{props.timeframeMonths == 1 ? <span> / <FormattedMessage id={ 'abo.new.text.month' } defaultMessage={ 'Monat'} /></span> : null}<br/>
                        <a style={{textDecoration:"none"}} onClick={props.handleStep(1)}>
                            {changeElement}
                        </a><br/>
                        <br/><br/>
                    </Col>
                    <Col xl={4} lg={4} md={4} sm={4} xs={12}>
                        <strong>
                            <FormattedMessage id={ 'abo.new.step3.delivery' } defaultMessage={ 'Lieferadresse'} />
                        </strong><br/>
                        {props.firstName} {props.lastName}<br/>
                        {props.line1}<br/>
                        {props.line2 != null && props.line2 != "" ? <>{props.line2}<br/></> : null}
                        CH-{props.postalcode} {props.city}<br/>
                        <a style={{textDecoration:"none"}} onClick={props.handleStep(2)}>
                            {changeElement}
                        </a>
                        <br/><br/>
                    </Col>
                </Row>
            </Card>
            <Row style={{paddingLeft:"0%", paddingRight:0, width: "100%", marginLeft:0}}>
                <Col lg={12} style={{textAlign: "left", fontSize:14, paddingTop:50, paddingLeft:0}}>
                        <h3>
                            <FormattedMessage id={ 'abo.new.navigation.step4.cc' } defaultMessage={ 'Bitte geben Sie Ihre Kreditkarte an'} />
                        </h3>
                        <p><FormattedMessage id={ 'abo.new.navigation.step4.payment.info' } defaultMessage={ 'Erste fällige Zahlung'} />: {props.couponInfo != null ? formatter.format(props.priceAmount-(props.couponInfo.percentOff*props.priceAmount)/100).replace(".00", ".-") : formatter.format(props.priceAmount).replace(".00", ".-")} ({props.couponInfo != null ?
                            <>{formatter.format((props.couponInfo.percentOff*props.priceAmount)/100).replace(".00", ".-")}<FormattedMessage id={ 'abo.new.navigation.step4.payment.reduction' } defaultMessage={ ' Rabatt auf 1. Zahlung, '} /></> : null}<FormattedMessage id={ 'abo.new.navigation.step4.payment.info.date' } defaultMessage={ 'erfolgt am '} />04.{(month+1).toString().padStart(2, '0')}.{year.toString().padStart(2, '0')})</p>
                            <Elements stripe={loadStripe("pk_live_g7T4M8nNeH1MRX4ygXMjKIue", { stripeAccount: "acct_1CGP2zHxVenJwvGf", locale: intl.locale == "en" ? "en" : "de" })}>
                                <StripeCreditCardForm
                                    backendUrl={getBackendUrl()+"vatia"}
                                    userId={"brauwolf"}
                                    priceId={props.priceId}
                                    priceAmount={props.priceAmount}
                                    timeframeMonths={props.timeframeMonths}
                                    couponCodeId={props.couponInfo != null && props.couponInfo.id != null ? props.couponInfo.id : null}
                                    firstName={props.firstName}
                                    lastName={props.lastName}
                                    line1={props.line1}
                                    line2={props.line2}
                                    postalcode={props.postalcode}
                                    city={props.city}
                                    country={props.country}
                                    email={props.email}
                                    phone={props.phone}
                                    setIsDone={props.setIsDone}
                                    width={props.width}
                                    breakpoint={props.breakpoint}
                                />
                            </Elements>
                </Col>
            </Row>
            {/*<Row style={{paddingLeft:"10%", paddingRight:"10%", marginTop:50,*/}
            {/*    width: 800, textAlign:"left", marginLeft:80, fontSize:14}}>*/}
            {/*    <button style={{backgroundColor:"#fff",border:0,borderRadius:4,color:"#e2e2e2",padding:6,marginTop:0, width: 50, height: 50}}*/}
            {/*            onClick={() => {props.handleBack()}}>*/}
            {/*        Zurück*/}
            {/*    </button>*/}
            {/*</Row>*/}
        </Row>
    </motion.div>)
}